<template>
  <v-card
    v-if="name"
    light
    outlined
    :class="$store.state.isMobile ? 'mx-0' : 'mx-3'"
  >
    <v-card-title class="font-weight-light pb-0"
      ><b> {{ $t(`messanger.filter.${name}.title`) }} : </b>
    </v-card-title>
    <v-card-text>
      <v-row
        justify="center"
        align="center"
        no-gutters
        v-if="name === 'status'"
      >
        <v-col sm="auto">
          <v-chip-group v-model="status_selected" column multiple>
            <v-chip
              class="ma-2"
              v-for="(st, i) in status"
              :key="i"
              filter
              :color="st.color"
              outlined
            >
              <b>{{ $t(`messanger.dash.status.${st.value}`) }}</b>
            </v-chip>
          </v-chip-group>
        </v-col>
        <v-btn @click="clear_chips" color="black" class="ml-1" icon
          ><v-icon>mdi-close</v-icon></v-btn
        >
        <v-btn
          @click="sort_status(name)"
          color="black"
          :dark="status_selected.length ? true : false"
          class="ml-5"
          :disabled="!status_selected.length"
          >{{ $t(`messanger.filter.filter_btn`) }}</v-btn
        >
      </v-row>
      <v-row
        justify="center"
        align="center"
        no-gutters
        v-else-if="name === 'status_email'"
      >
        <v-col sm="auto">
          <v-chip-group v-model="status_selected" column multiple>
            <v-chip
              class="ma-2"
              v-for="(st, i) in email_status"
              :key="i"
              filter
              :color="st.color"
              outlined
            >
              <b>{{ $t(`messanger.dash.email_status.${st.value}`) }}</b>
            </v-chip>
          </v-chip-group>
        </v-col>
        <v-btn @click="clear_chips" color="black" class="ml-1" icon
          ><v-icon>mdi-close</v-icon></v-btn
        >
        <v-btn
          @click="sort_status(name)"
          color="black"
          :dark="status_selected.length ? true : false"
          class="ml-5"
          :disabled="!status_selected.length"
          >{{ $t(`messanger.filter.filter_btn`) }}</v-btn
        >
      </v-row>
      <v-row justify="center" v-else>
        <v-col cols="auto">
          <v-btn
            :class="$store.state.isMobile ? 'mx-0' : 'mx-4'"
            :small="$store.state.isMobile ? true : false"
            @click="sort_cr(name)"
            color="black"
            :dark="!btns.btn1"
            :disabled="btns.btn1"
          >
            {{ $t(`messanger.filter.${name}.btn1`) }}</v-btn
          >
        </v-col>
        <v-col cols="auto">
          <v-btn
            :class="$store.state.isMobile ? 'mx-0' : 'mx-4'"
            :small="$store.state.isMobile ? true : false"
            @click="sort_decr(name)"
            color="black"
            :dark="!btns.btn2"
            :disabled="btns.btn2"
            >{{ $t(`messanger.filter.${name}.btn2`) }}</v-btn
          >
        </v-col>
      </v-row>
    </v-card-text>
    <v-expansion-panel v-if="name === 'sent_at' || name === 'waiting'">
      <v-expansion-panel-header color="white" v-slot="{ open }">
        <v-row no-gutters>
          <v-col cols="4">
            <b> {{ $t(`messanger.filter.${name}.date`) }}</b>
          </v-col>
          <v-col cols="8" class="text--secondary">
            <v-fade-transition leave-absolute>
              <span v-if="open">{{
                $t(`messanger.filter.${name}.question`)
              }}</span>
              <v-row v-else no-gutters style="width: 100%">
                <v-col cols="6">
                  {{ $t(`messanger.filter.${name}.sd`) }}:
                  {{
                    $store.state.messages.sorts[name].between.start ||
                    $t(`messanger.filter.${name}.not_set`)
                  }}
                </v-col>
                <v-col cols="6">
                  {{ $t(`messanger.filter.${name}.ed`) }}:
                  {{
                    $store.state.messages.sorts[name].between.end ||
                    $t(`messanger.filter.${name}.not_set`)
                  }}
                </v-col>
              </v-row>
            </v-fade-transition>
          </v-col>
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row justify="space-around" no-gutters>
          <v-col cols="12 " sm="3">
            <v-menu
              ref="startMenu"
              :close-on-content-click="false"
              :return-value.sync="
                $store.state.messages.sorts[name].between.start
              "
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="$store.state.messages.sorts[name].between.start"
                  :label="$t(`messanger.filter.${name}.sd`)"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  clearable
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date_tooken"
                no-title
                scrollable
                color="primary"
                :locale="$i18n.locale"
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.startMenu.isActive = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.startMenu.save(date_tooken)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" sm="3">
            <v-menu
              ref="endMenu"
              :close-on-content-click="false"
              :return-value.sync="$store.state.messages.sorts[name].between.end"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :disabled="!$store.state.messages.sorts[name].between.start"
                  v-model="$store.state.messages.sorts[name].between.end"
                  :label="$t(`messanger.filter.${name}.sd`)"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  clearable
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date_tooken"
                no-title
                scrollable
                color="primary"
                :locale="$i18n.locale"
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.endMenu.isActive = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.endMenu.save(date_tooken)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="auto">
            <v-btn
              :disabled="
                !$store.state.messages.sorts[name].between.start ||
                !$store.state.messages.sorts[name].between.end
              "
              :dark="
                $store.state.messages.sorts[name].between.start &&
                $store.state.messages.sorts[name].between.end
                  ? true
                  : false
              "
              color="black"
              @click="sort_between(name)"
            >
              {{ $t(`messanger.filter.filter_btn`) }}
            </v-btn>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-card>
</template>

<script>
export default {
  name: "filters",
  props: {
    name: null,
    data: null,
    btns: null,
  },
  data: () => ({
    date_tooken: null,
    status_selected: [],
  }),
  computed: {
    status() {
      return this.$store.state.messages.status;
    },
    email_status() {
      return this.$store.state.messages.email_status;
    },
  },
  mounted: function () {
    //console.log("->", this.name, this.data);
  },
  methods: {
    sort_cr(col) {
      const avilable_filters = [
        "sent_at",
        "waiting",
        "online",
        "priority",
        "add_to_cart",
        "purchase",
      ];
      if (avilable_filters.includes(col)) {
        this.btns.btn1 = true;
        this.btns.btn2 = false;
        this.$store.state.messages.sorts[col].order = true;
        this.$store.state.messages.sorts[col].des_order = false;
        this.$store.dispatch("setCloader", { showing: true });
        if (col === "sent_at" || col === "waiting")
          this.$store.dispatch("filter_date", col).then((r) => {
            this.$store.dispatch("setCloader", { showing: false });
            this.$store.state.messages.filter_panel_open = [];
          });
        else if (
          col === "online" ||
          col === "priority" ||
          col === "add_to_cart" ||
          col === "purchase"
        )
          this.$store.dispatch("filter_bools", col).then((r) => {
            this.$store.dispatch("setCloader", { showing: false });
            this.$store.state.messages.filter_panel_open = [];
          });
      }
    },
    sort_decr(col) {
      const avilable_filters = [
        "sent_at",
        "waiting",
        "online",
        "priority",
        "add_to_cart",
        "purchase",
      ];
      if (avilable_filters.includes(col)) {
        this.btns.btn2 = true;
        this.btns.btn1 = false;
        this.$store.state.messages.sorts[col].order = false;
        this.$store.state.messages.sorts[col].des_order = true;
        this.$store.dispatch("setCloader", { showing: true });
        if (col === "sent_at" || col === "waiting")
          this.$store.dispatch("filter_date", col).then((r) => {
            this.$store.dispatch("setCloader", { showing: false });
            this.$store.state.messages.filter_panel_open = [];
          });
        else if (
          col === "online" ||
          col === "priority" ||
          col === "add_to_cart" ||
          col === "purchase"
        )
          this.$store.dispatch("filter_bools", col).then((r) => {
            this.$store.dispatch("setCloader", { showing: false });
            this.$store.state.messages.filter_panel_open = [];
          });
      }
    },
    sort_between(col) {
      this.$store.dispatch("setCloader", { showing: true });
      this.$store.dispatch("filter_date", col).then((res) => {
        //console.log(res);
        if (res && res.error) {
          this.$store.dispatch("setSnackbar", {
            showing: true,
            text: "End date is less then start date please check again",
          });
          this.$store.state.messages.filter_rest = this.$store.state.messages.all_messages;
        }
        this.$store.dispatch("setCloade r", { showing: false });
        this.$store.state.messages.filter_panel_open = [];
      });
    },
    sort_status(col) {
      this.$store.state.messages.sorts[
        col
      ].filter_by = this.status_selected.map((m) => {
        if (col === "status") return this.status[m].value;
        else return this.email_status[m].value;
      });
      this.$store.dispatch("setCloader", { showing: true });
      this.$store.dispatch("filter_status", col).then((r) => {
        this.$store.dispatch("setCloader", { showing: false });
        this.$store.state.messages.filter_panel_open = [];
      });
    },
    clear_chips() {
      this.status_selected = [];
      this.$store.state.messages.filter_rest = this.$store.state.messages.all_messages;
      if (this.$store.state.messages.sorts.selected_sort) {
        this.$store.state.messages.sorts[
          this.$store.state.messages.sorts.selected_sort
        ].filter_by = [];
        this.$store.state.messages.sorts.selected_sort = "";
      }
    },
  },
};
</script>
<style scoped></style>
